// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const AdminLocationProvider = registerClientReference(
    function() { throw new Error("Attempted to call AdminLocationProvider() from the server but AdminLocationProvider is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/admin/admin-location-provider.tsx",
    "AdminLocationProvider",
);
export const useAdminLocation = registerClientReference(
    function() { throw new Error("Attempted to call useAdminLocation() from the server but useAdminLocation is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/admin/admin-location-provider.tsx",
    "useAdminLocation",
);
